import React from "react";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

type ErrorMessageProps = {
  message?: string;
  type?: "error" | "warning" | "success" | "info";
  className?: string;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  type = "error",
  className = "",
}) => {
  const { t } = useTranslation();
  if (!message) return null;
  const getMessageClassName = () => {
    let baseClass = styles.message;
    switch (type) {
      case "error":
        baseClass += ` ${styles.error}`;
        break;
      case "warning":
        baseClass += ` ${styles.warning}`;
        break;
      case "success":
        baseClass += ` ${styles.success}`;
        break;
      case "info":
        baseClass += ` ${styles.info}`;
        break;
      default:
        baseClass += ` ${styles.error}`;
    }

    if (className) {
      baseClass += ` ${className}`;
    }

    return baseClass;
  };
  return (
    <div className={styles.container}>
      <span className={getMessageClassName()}>{t(message)}</span>
    </div>
  );
};

export default ErrorMessage;
